"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopSetting = void 0;
var DesktopSetting;
(function (DesktopSetting) {
    DesktopSetting["animateMiniMode"] = "animateMiniMode";
    DesktopSetting["autoMiniMode"] = "autoMiniMode";
    DesktopSetting["autoMiniModeOnScreenShare"] = "autoMiniModeOnScreenShare";
    DesktopSetting["autoUpdates"] = "autoUpdates";
    DesktopSetting["openAtLogin"] = "openAtLogin";
    DesktopSetting["chatNotifications"] = "chatNotifications";
    DesktopSetting["eventNotifications"] = "eventNotifications";
    DesktopSetting["autoDnd"] = "autoDnd";
    DesktopSetting["rejoinReminders"] = "rejoinReminders";
    DesktopSetting["selectedLanguage"] = "selectedLanguage";
    DesktopSetting["nativePickerDisabled"] = "nativePickerDisabled";
})(DesktopSetting || (exports.DesktopSetting = DesktopSetting = {}));
//# sourceMappingURL=desktopSettings.js.map